import React, {
    useCallback,
    useContext,
    useEffect,
    useState
} from "react";
import axios from "axios";
import {
    Link
} from "react-router-dom";
import {
    OverlayTrigger,
    Tooltip
} from "react-bootstrap";
import {
    Title
} from "@zandor300/backoffice-framework";

import ShopsContext from "../../context/ShopsContext";
import TagPill from "../../components/pills/TagPill";
import Helmet from "../../components/Helmet";
import DiscountCodesTable from "./DiscountCodesTable";

function DiscountCodes() {
    const shopsContext = useContext(ShopsContext);
    const [discountCodes, setDiscountCodes] = useState(null);
    const [error, setError] = useState(null);

    const baseUrl = "/shop/" + shopsContext.currentShop.codeName;

    const getDiscountCodes = useCallback(async () => {
        setDiscountCodes(null);
        setError(null);
        try {
            const response = await axios.post("/getDiscountCodes", {
                shopId: shopsContext.currentShop.id,
            });
            if(response.data.valid) {
                setDiscountCodes(response.data.discountCodes);
            } else {
                setError("Er ging iets fout. Probeer het later opnieuw. (" + response.data.error + ")");
            }
        } catch(requestError) {
            console.error(requestError);
            setError("Er ging iets fout. Probeer het later opnieuw.");
        }
    }, [shopsContext.currentShop.id]);

    useEffect(() => {
        getDiscountCodes();
    }, [getDiscountCodes]);

    const handleToggleEnabled = useCallback(async (discountCodeId, enabled) => {
        setDiscountCodes(prev => prev ? prev.map(dc =>
            dc.id === discountCodeId ? { ...dc, enabled } : dc
        ) : prev);
        try {
            const response = await axios.post("/setDiscountCodeEnabled", {
                shopId: shopsContext.currentShop.id,
                discountCodeId,
                enabled: enabled ? 1 : 0,
            });
            if(!response.data.valid) {
                setDiscountCodes(prev => prev ? prev.map(dc =>
                    dc.id === discountCodeId ? { ...dc, enabled: !enabled } : dc
                ) : prev);
                setError("Er ging iets fout bij het wijzigen van de status. (" + response.data.error + ")");
            }
        } catch(requestError) {
            console.error(requestError);
            setDiscountCodes(prev => prev ? prev.map(dc =>
                dc.id === discountCodeId ? { ...dc, enabled: !enabled } : dc
            ) : prev);
            setError("Er ging iets fout bij het wijzigen van de status. Probeer het later opnieuw.");
        }
    }, [shopsContext.currentShop.id]);

    return (
        <React.Fragment>
            <Helmet title="Kortingscodes"/>
            <Title
                noBottom
                preTitle="Overzicht"
                preChildren={
                    <div className="float-right mt-2">
                        <OverlayTrigger overlay={
                            <Tooltip id="newDiscountCode">Nieuwe kortingscode</Tooltip>
                        }>
                            <Link
                                to={ baseUrl + "/discount-codes/add" }
                                className="btn btn-secondary float-right mt-2"
                            >
                                <i className="fas fa-fw fa-plus"/>
                            </Link>
                        </OverlayTrigger>
                    </div>
                }
            >
                Kortingscodes
                <small>
                    <TagPill className="ml-2">{ discountCodes ? discountCodes.length : 0 }</TagPill>
                </small>
            </Title>
            <DiscountCodesTable
                discountCodes={ discountCodes }
                error={ error }
                baseUrl={ baseUrl }
                onToggleEnabled={ handleToggleEnabled }
            />
        </React.Fragment>
    );
}

export default React.memo(DiscountCodes);
